import React, { Component } from 'react'
import { validateCaptcha } from 'react-simple-captcha'
import Modal from 'react-modal'
import modalStyle from '../../_common/core/modalStyle'
import Button from '../_library/Button'
import Captcha from './Captcha'

class CaptchaModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      captchaValue: '',
      showModal: false,
      captchaError: '',
    }
    this.pendingFormData = null
    this.pendingHelperFunctions = null
  }

  openCaptchaModal = (formData, helperFunctions) => {
    this.pendingFormData = formData
    this.pendingHelperFunctions = helperFunctions
    this.setState({
      showModal: true,
      captchaValue: '',
      captchaError: '',
    })

    return new Promise((resolve, reject) => {
      reject()
    })
  }

  closeCaptchaModal = () => {
    this.setState({
      showModal: false,
      captchaValue: '',
      captchaError: '',
    })

    if (this.pendingHelperFunctions?.setSubmitting) {
      this.pendingHelperFunctions.setSubmitting(false)
    }

    this.pendingFormData = null
    this.pendingHelperFunctions = null
  }

  handleCaptchaSubmit = async () => {
    const { onSubmit } = this.props
    const { captchaValue } = this.state

    if (!captchaValue) {
      this.setState({ captchaError: 'Please enter the captcha code' })
      return
    }

    const isValid = validateCaptcha(captchaValue)

    if (!isValid) {
      this.setState({
        captchaError: 'Invalid captcha code. Please try again.',
        captchaValue: '',
      })
      return
    }

    if (this.pendingHelperFunctions?.setSubmitting) {
      this.pendingHelperFunctions.setSubmitting(true)
    }
    onSubmit(this.pendingFormData)
    this.closeCaptchaModal()
  }

  render() {
    const { children } = this.props
    const { showModal, captchaValue, captchaError } = this.state

    return (
      <div>
        {children && typeof children === 'function'
          ? children({
              handleSubmit: this.openCaptchaModal,
            })
          : children}

        <Modal
          className="modal-dialog modal-trans"
          style={modalStyle}
          isOpen={showModal}
          contentLabel="Captcha Verification"
          onRequestClose={this.closeCaptchaModal}
          closeTimeoutMS={150}
          ariaHideApp={false}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <p className="h4 text-compact">Security Verification</p>
              </div>
              <div className="modal-body">
                <Captcha
                  captchaValue={captchaValue}
                  setCaptchaValue={value => this.setState({ captchaValue: value })}
                  captchaError={captchaError}
                  setCaptchaError={error => this.setState({ captchaError: error })}
                />
              </div>
              <div className="modal-footer">
                <div className="btn-toolbar btn-toolbar-right">
                  <Button className="btn btn-primary" type="button" onClick={this.handleCaptchaSubmit}>
                    Verify & Submit
                  </Button>
                  <Button className="btn btn-cancel" type="button" onClick={this.closeCaptchaModal}>
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}

export default CaptchaModal
